<template>
    <form-accordion
        name="title"
        section="Title"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <title-commitment-date
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <title-who-pays
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <title-company
            :closing="property.closing"
            :read_only="read_only"
        />

        <title-agent
            :closing="property.closing"
            :available_contacts="available_contacts"
            :read_only="read_only"
        />

        <entitlement-period-index
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <final-plat-index
            :commercial="property.commercial"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import TitleCommitmentDate from './title-commitment-date.vue';
import TitleWhoPays from './title-who-pays.vue';
import TitleCompany from './title-company.vue';
import TitleAgent from './title-agent.vue';
import EntitlementPeriodIndex from './entitlement-period/entitlement-period-index.vue';
import FinalPlatIndex from './final-plat/final-plat-index.vue';

export default {
    components: {
        TitleCommitmentDate,
        TitleWhoPays,
        TitleCompany,
        TitleAgent,
        EntitlementPeriodIndex,
        FinalPlatIndex,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
        available_contacts: { default: () => [] },
    },
}
</script>
